import { SpeedInsights } from "@vercel/speed-insights/next";
import { useRouter } from "next/compat/router";
import Script from "next/script";
import type * as React from "react";
import { useEffect } from "react";

import * as fbq from "~/lib/fpixel";

declare global {
	interface Window {
		fbq: {
			(
				command: string,
				eventType: string,
				params?: Record<string, unknown>,
			): void;
			loaded?: boolean;
			version?: string;
			queue?: unknown[];
		};
	}
}

const Scripts: React.FC = () => {
	const router = useRouter();

	useEffect(() => {
		// Don't call fbq.pageView() immediately, instead call onLoad in script
		// (this allows us to defer Facebook tracking pixel loading to after the
		// initial page load)

		// Continue to listen for future route changes
		const handleRouteChange = () => {
			// Guard: Just in case user navigates extremely fast
			// before lazy load finishes.
			if (typeof window.fbq === "function") {
				fbq.pageView();
			}
		};

		router?.events.on("routeChangeComplete", handleRouteChange);
		return () => {
			router?.events.off("routeChangeComplete", handleRouteChange);
		};
	}, [router?.events]);

	return (
		<>
			<SpeedInsights />

			<Script
				id="fb-pixel"
				strategy="lazyOnload"
				onLoad={() => {
					// This runs ONLY after the script is loaded and fbq is defined
					fbq.pageView();
				}}
				dangerouslySetInnerHTML={{
					__html: `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ${fbq.FB_PIXEL_ID});
  `,
				}}
			/>

			<Script
				src={`https://www.googletagmanager.com/gtag/js?id=AW-973693105`}
				strategy="lazyOnload"
			/>

			<Script async id="google-ads" strategy="lazyOnload">
				{`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'AW-973693105');
    `}
			</Script>

			<Script
				async
				src={`https://www.googletagmanager.com/gtag/js?id=G-WQRZCZKWPX`}
				strategy="lazyOnload"
			/>

			<Script async id="google-analytics" strategy="lazyOnload">
				{`
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-WQRZCZKWPX');
    `}
			</Script>

			<Script async id="bing-tag" strategy="lazyOnload">
				{`
    (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"134631386", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
  `}
			</Script>

			<Script async id="google-ads" strategy="lazyOnload">
				{`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'AW-973693105');
    `}
			</Script>

			<Script async id="google-analytics" strategy="lazyOnload">
				{`
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-WQRZCZKWPX');
    `}
			</Script>

			<Script async id="reddit-pixel" strategy="lazyOnload">
				{`
    !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_g11c5boyjy1t');rdt('track', 'PageVisit');
  `}
			</Script>
		</>
	);
};

export default Scripts;
